import {
  EntityDropdownInputBare,
  type EntityDropdownInputBareProps,
} from "#batteries-included-components/Dropdowns/EntityDropdownInputBare";
import useLocalization from "#src/hooks/useLocalization";
import { FlowAdapter } from "@validereinc/domain";
import React from "react";

/**
 * Uncontrolled Flow dropdown using DropdownInputBare for use in FilterBuilder.
 * Value is controlled by parent (e.g. filter state); does not register with react-hook-form.
 */
export const FlowDropdownInputBare = (
  props: Omit<EntityDropdownInputBareProps<unknown>, "fetchEntityList">
) => {
  const { localize } = useLocalization();

  return (
    <EntityDropdownInputBare
      fetchEntityList={FlowAdapter.getList}
      label={props.label ?? localize("Flow")}
      {...props}
    />
  );
};
